"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";

// biome-ignore lint/suspicious/noShadowRestrictedNames: Next.js requires this export name for error boundaries
export default function Error({
	error,
	reset,
}: {
	error: Error & { digest?: string };
	reset: () => void;
}) {
	useEffect(() => {
		console.error("Error boundary caught:", error);
		Sentry.captureException(error);
	}, [error]);

	return (
		<div className="flex min-h-screen items-center justify-center">
			<div className="text-center">
				<h2 className="text-2xl font-bold">Something went wrong!</h2>
				<Button type="button" onClick={() => reset()} className="mt-4">
					Try again
				</Button>
			</div>
		</div>
	);
}
